import React, { useMemo } from 'react';

import { rangePresets } from '@gogame/intl-ts';

import { PERIOD } from 'scenes/PlayersActivities/PlayersInformation/constants';

import RequestForm from './RequestForm';

function cleanEmptyValues(obj) {
  const newObj = { ...obj };
  Object.keys(newObj).forEach((key) => {
    if (Array.isArray(newObj[key])) {
      if (newObj[key].length === 0) {
        delete newObj[key];
      }
    } else if (newObj[key] === '') {
      delete newObj[key];
    }
  });
  return newObj;
}

const Request = (props) => {
  const handleSubmit = async (values) => {
    props?.onSubmit(cleanEmptyValues(values));
  };

  const initialValues = useMemo(() => {
    return {
      [PERIOD]: rangePresets.THIS_MONTH.value,
    };
  }, []);

  return (
    <RequestForm
      {...props}
      initialValues={initialValues}
      onSubmit={handleSubmit}
    />
  );
};

export default Request;
